import React, { useState, useEffect } from "react";
import { FiChevronRight, FiChevronLeft } from "react-icons/fi";
import { FaQuoteRight } from "react-icons/fa";
import data from "./data";

function App() {
  const [users, setUsers] = useState(data);
  const [value, setValue] = useState(0);

  useEffect(() => {
    const lastIndex = users.length - 1;
    if (value < 0) {
      setValue(lastIndex);
    }
    if (value > lastIndex) {
      setValue(0);
    }
  }, [value, users]);

  useEffect(() => {
    let interval = setInterval(() => {
      setValue(value + 1);
    }, 3000);
    return () => clearInterval(interval); // clearing interval to prevent for unsual behavior
  }, [value]);

  // console.log(value);
  return (
    <section className="section">
      <div className="title">
        <h2>
          <span>/</span>Reviews
        </h2>
      </div>
      <div className="section-center">
        {users.map((user, index) => {
          const { id, image, name, title, quote } = user;

          let slide = "nextSlide";
          if (index === value) {
            slide = "activeSlide";
          }

          if (
            index === value - 1 ||
            (value === 0 && index === users.length - 1)
          ) {
            slide = "lastSlide";
          }

          return (
            <article key={id} className={`${slide}`}>
              <img className="person-img" src={image} alt={id} />
              <h4>{name}</h4>
              <p className="title">{title}</p>
              <p className="text">{quote}</p>
              <FaQuoteRight />
            </article>
          );
        })}
        <button onClick={() => setValue(value - 1)} className="prev">
          <FiChevronLeft />
        </button>
        <button onClick={() => setValue(value + 1)} className="next">
          <FiChevronRight />
        </button>
      </div>
    </section>
  );
}

export default App;
